<app-topbar></app-topbar>
<main class="layout-container">
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="grid justify-content-center">
        <div class="col-12 md:col-10">
          <p class="md:text-3xl font-semibold md:font-normal mt-0 mb-2">Seja bem-vindo à Base de Conhecimento do Banco
            de Prompt </p>
          <p class="text-600 mb-4">Aqui, você encontra tudo o que precisa para utilizar o Banco de Prompt.
            Baixe o manual ou assista aos vídeos tutoriais para aprender de forma fácil e rápida!</p>

          <section class="manual-prompt-section">
            <h2 class="text-900 text-xl md:text-2xl font-semibold mt-0 mb-2">Documentos</h2>
            <ul class="list-none px-0 pb-0 pt-3 m-0 border-top-1 surface-border manual-prompt-grid">
              <li class="py-2 border-round border-1 border-300 p-3 bg-white">
                <a href="assets/docs/Manual_Promptus.pdf" target="_blank" rel="noopener noreferrer"
                  class="no-underline text-inherit" aria-label="Abrir Manual Promptus (PDF) em nova aba">
                  <div class="flex align-items-center">
                    <span
                      class="inline-flex align-items-center justify-content-center bg-indigo-500 border-round flex-shrink-0 bg-icon">
                      <i class="pi pi-file-pdf text-white md:text-3xl"></i>
                    </span>
                    <div class="ml-3">
                      <span class="text-900 font-medium md:text-lg inline-block mb-1">Manual Promptus</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="py-2 border-round border-1 border-300 p-3 bg-white">
                <a href="assets/docs/FAQ_Promptus.pdf" target="_blank" rel="noopener noreferrer"
                  class="no-underline text-inherit" aria-label="Abrir FAQ Banco de Prompt (PDF) em nova aba">
                  <div class="flex align-items-center">
                    <span
                      class="inline-flex align-items-center justify-content-center bg-indigo-500 border-round flex-shrink-0 bg-icon">
                      <i class="pi pi-file-pdf text-white md:text-3xl"></i>
                    </span>
                    <div class="ml-3">
                      <span class="text-900 font-medium md:text-lg inline-block mb-1">FAQ Promptus</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="py-2 border-round border-1 border-300 p-3 bg-white">
                <a href="assets/docs/Manual_Operacao_Promptus.pdf" target="_blank" rel="noopener noreferrer"
                  class="no-underline text-inherit" aria-label="Abrir Manual de Operação Promptus (PDF) em nova aba">
                  <div class="flex align-items-center">
                    <span
                      class="inline-flex align-items-center justify-content-center bg-indigo-500 border-round flex-shrink-0 bg-icon">
                      <i class="pi pi-file-pdf text-white md:text-3xl"></i>
                    </span>
                    <div class="ml-3">
                      <span class="text-900 font-medium md:text-lg inline-block mb-1">Manual de Operação Promptus</span>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </section>

          <!-- Retirada temporária de vídeos conforme issue 16 -->

          <!-- <section class="manual-prompt-section">
            <h2 class="text-900 text-xl md:text-2xl font-semibold mt-0 mb-2">Vídeos</h2>
            <ul class="list-none px-0 pb-0 pt-3 m-0 border-top-1 surface-border manual-prompt-grid">
              <li class="py-2 border-round border-1 border-300 p-3 bg-white">
                <div class="flex align-items-center mb-3">
                  <span
                    class="inline-flex align-items-center justify-content-center bg-red-500 border-round flex-shrink-0 bg-icon">
                    <i class="pi pi-youtube text-white md:text-3xl"></i>
                  </span>
                  <div class="ml-3">
                    <span class="text-900 font-medium md:text-lg inline-block mb-1"> Como usar o Banco de Prompt?</span>
                    <p class="text-600 m-0 line-height-3">Vídeo Tutorial</p>
                  </div>
                </div>
                <div class="video-container">
                  <iframe loading="lazy" src="https://www.youtube.com/embed/lVXWFMHR5jQ"
                    title="Como usar o Banco de Prompt" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                  </iframe>
                </div>
              </li>

              <li class="py-2 border-round border-1 border-300 p-3 bg-white">
                <div class="flex align-items-center mb-3">
                  <span
                    class="inline-flex align-items-center justify-content-center bg-red-500 border-round flex-shrink-0 bg-icon">
                    <i class="pi pi-youtube text-white md:text-3xl"></i>
                  </span>
                  <div class="ml-3">
                    <span class="text-900 font-medium md:text-lg inline-block mb-1"> Como cadastrar um novo prompt no
                      banco?</span>
                    <p class="text-600 m-0 line-height-3">Vídeo Tutorial</p>
                  </div>
                </div>
                <div class="video-container">
                  <iframe loading="lazy" src="https://www.youtube.com/embed/Z7J3tRmcm9c"
                    title="Como cadastrar um novo prompt no banco" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                  </iframe>
                </div>
              </li>

              <li class="py-2 border-round border-1 border-300 p-3 bg-white">
                <div class="flex align-items-center mb-3">
                  <span
                    class="inline-flex align-items-center justify-content-center bg-red-500 border-round flex-shrink-0 bg-icon">
                    <i class="pi pi-youtube text-white md:text-3xl"></i>
                  </span>
                  <div class="ml-3">
                    <span class="text-900 font-medium md:text-lg inline-block mb-1"> Como duplicar o prompt?</span>
                    <p class="text-600 m-0 line-height-3">Vídeo Tutorial</p>
                  </div>
                </div>
                <div class="video-container">
                  <iframe loading="lazy" src="https://www.youtube.com/embed/ashnR1DHBwE" title="Como duplicar o prompt"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                  </iframe>
                </div>
              </li>
            </ul>
          </section> -->
        </div>
      </div>
    </div>
  </div>
</main>
